import React from "react";
// styled components
import { Modal, Button, Row, Col, Table, Empty } from "antd";

interface IProps {
  modal: boolean;
  CancelarModal: any;
  jurado: any;
  codigo: string;
  lineasconvocatoria: any;
}

export const ModalVerProyectos: React.FC<IProps> = (props: IProps) => {
  const columns: any = [
    {
      title: "No.",
      width: 60,
      render: (datos: any, datos2: any, index: number) => {
        return <span>{index + 1}</span>;
      },
    },
    {
      title: "Nombre proyecto",
      width: 200,
      dataIndex: "nombre_propuesta",
      key: "nombre_propuesta",
    },
    {
      title: "Codigo",
      width: 200,
      dataIndex: "radicado",
      key: "radicado",
    }
  ];
  return (
    <>
      <Modal
        title={
          <span className="font-size-12px font-family-Montserrat-Regular">
            <span style={{ fontWeight: 'bold' }}>Datos de Jurado : </span>
            {props.jurado.primer_nombre} {props.jurado.primer_apellido} <span style={{ fontWeight: 'bold' }}> Código: </span>
            {props.jurado.radicado}
          </span>
        }
        style={{ top: 20 }}
        visible={props.modal}
        onCancel={props.CancelarModal}
        closeIcon="X"
        width={1400}
        footer={[
          <Button key="B_CerrarModalverPro" className="button-gray-ghost" onClick={props.CancelarModal}>
            CERRAR
          </Button>,
        ]}
        bodyStyle={{
          padding: 0,
        }}
        maskStyle={{
          backgroundColor: "rgba(31,174,239,0.8)",
          borderRadius: "6px",
        }}
      >
        <Row className="width-100" style={{ padding: "16px" }}>
          <Col span={24}>
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
              //   pagination={{ position: ["bottomRight"], itemRender: itemRenderTable, pageSize: cantidadpáginas }}
              dataSource={props.jurado.asignado}
              columns={columns}
              size="small"
              bordered={false}
            />
          </Col>
        </Row>
      </Modal>
    </>
  );
};
